export default __webpack_public_path__ + "static/media/mainlogo.955ad720.jpg";